class Overlay {
  constructor() {
    this.classes = {
      active: 'overlay--active',
    };

    this.element = document.createElement('div');
    this.element.classList.add('overlay');

    this.create = this.create.bind(this);
    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.toggleDisabledElements = this.toggleDisabledElements.bind(this);
    this.disabledElements = [...document.querySelectorAll('[disabled-under-overlay]')];
  }

  create(selector) {
    const defaultTarget = () => document.body.appendChild(this.element);

    if (selector && selector !== '') {
      const target = document.querySelector(selector);

      if (target) target.appendChild(this.element);
      else defaultTarget();
    } else defaultTarget();
  }

  toggle() {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  toggleDisabledElements(disable) {
    this.disabledElements.forEach((el) => {
      if (disable) {
        el.classList.add('pointer-events-none');
      } else {
        el.classList.remove('pointer-events-none');
      }
    });
  }

  show() {
    this.element.classList.add(this.classes.active);
    this.toggleDisabledElements(true);
  }

  hide() {
    this.element.classList.remove(this.classes.active);
    this.toggleDisabledElements(false);
  }
}

const overlay = new Overlay();

export const { show, hide, create } = overlay;
